import CONSTANTS from '../../constants';

export function account(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.MEMBER.GET.ACCOUNT:
            return action.account;
        default:
            return state
    }
}